module.exports = __webpack_public_path__ + "static/media/capacity.686e7452.svg";